const images = [
  {
    SubTitleText:"Tom Hiddleston in The Essex Serpent",
    MainImageurl:
      "https://m.media-amazon.com/images/M/MV5BZGViMTdkZmEtNDU0Ny00ZDUxLWE1NTMtYzUzODVlMTExZjY5XkEyXkFqcGdeQXVyMTEyMjM2NDc2._CR267,0,3573,2010_QL75_UX1000_CR0,0,1000,563_.jpg",
    subTitleImg:
      "https://m.media-amazon.com/images/M/MV5BN2M2MTNkMmEtYjRjOC00ZGNjLTlmZjItOWI4MWY1YTBiMDFkXkEyXkFqcGdeQXVyMTQxMzg4NjQy._V1_QL75_UX280_CR0,8,280,414_.jpg",
  },
  {
    SubTitleText:"The Rise of Andrew Garfield",
    MainImageurl:
      "https://m.media-amazon.com/images/M/MV5BMThiMjRhOGEtOWQ3Zi00YTM3LTg3NTAtNGJiMTg3NTBhMGIwXkEyXkFqcGdeQXVyNjY1MTg4Mzc@._CR37,467,4160,2340_QL75_UX1000_CR0,0,1000,563_.jpg",
    subTitleImg:
      "https://m.media-amazon.com/images/M/MV5BOWY2OGY3MjktMDA1Ny00NDJkLTllMTEtMWVhNjg1MWQ2YmQ3XkEyXkFqcGdeQXVyNDYzNjU3ODM@._V1_QL75_UX280_CR0,0,280,414_.jpg",
  },
  {
    SubTitleText:"First Look THOR : Love and Thunder",
    MainImageurl:
      "https://m.media-amazon.com/images/M/MV5BYjliMThkNGYtMmIxNS00YmE0LWI3ODUtYWE3ZTRkOGNlNDk5XkEyXkFqcGdeQWpnYW1i._V1_QL40_QL75_UX1000_CR0,0,1000,563_.jpg",
    subTitleImg:
      "https://m.media-amazon.com/images/M/MV5BMzJjZWYzNTctODgwOS00OGNiLTg4MjktMDlmNWUxNjczMzljXkEyXkFqcGdeQXVyMTM1MTE1NDMx._V1_QL75_UX280_CR0,0,280,414_.jpg",
  },
];
export default images;
